var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[(_vm.show)?_c('v-date-picker',{attrs:{"rules":_vm.rules,"label":_vm.$t('userData.personalProfile.dob'),"required":""},on:{"change":function($event){return _vm.$emit('setDOB', _vm.localDOB)}},model:{value:(_vm.localDOB),callback:function ($$v) {_vm.localDOB=$$v},expression:"localDOB"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }